<template>
    <clients-section title="They Chose Us|Ils nous ont choisis">
        <client-card src="img/clients-color/real-estate/cominar.png">
            Cominar
        </client-card>
        <client-card src="img/clients-color/real-estate/westcliff.png">
            Westcliff
        </client-card>
        <client-card src="img/clients-color/real-estate/cushman-wakefield.png" bg>
            Cushman Wakefield
        </client-card>
        <client-card src="img/clients-color/real-estate/bental-kennedy.png" bg>
            BentallGreenOak
        </client-card>
        <client-card src="img/clients-color/real-estate/ivanhoe_cambridge.png">
            Ivanhoe Cambridge
        </client-card>
        <client-card src="img/clients-color/real-estate/morguard.png" bg>
            Morguard
        </client-card>
        <client-card src="img/clients-color/real-estate/porto-bellagio-condos.jpg">
            Porto Bellagio Condos
        </client-card>
        <client-card src="img/clients-color/real-estate/cogir.png" bg>
            Cogir
        </client-card>
        <client-card src="img/clients-color/banks/mouvement_desjardins.png">
            Mouvement Desjardins
        </client-card>
    </clients-section>
</template>

<script>

import ClientCard from "@/components/client-card.vue";
import ClientsSection from "@/components/clients-section.vue";
export default {
    name: `wifi-real-estate-client-card`,
    components: {ClientCard, ClientsSection},
    data() {
        return {
            altPrefix: this.tr(`Real Estate Guest WiFi Clients|Client immobilier wifi social`)
        }
    }
}
</script>

<style lang="scss" scoped>
</style>
